import { getInvoices } from './../state/invoice/invoice.actions';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import CustomerService from './CustomerService';
import { Observable, of, switchMap } from 'rxjs';
import { Invoice } from '../models/Invoice';

@Injectable()
export default class InvoiceService {
  baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/`;
  headers: HttpHeaders;
  constructor(
    private http: HttpClient,
    private customerService: CustomerService
  ) {
    this.headers = new HttpHeaders();
  }

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    if (token) {
      return new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
    }
    return new HttpHeaders();
  }

  getInvoices(customerNo: number): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(
      this.baseUrl + 'Gateway/customers/' + customerNo + '/invoices'
    );
  }

  getInvoiceByOrderNo(orderNo: string, customerNo: number): Observable<Invoice> {
    return this.http.get<Invoice>(
      this.baseUrl + 'Gateway/customers/' + customerNo + '/invoices/by-order/' + orderNo,
      { headers: this.getHeaders() }
    );
  }
}
